<template>
	<div class="file-browser">
		<div
			class="file-table-header file-table-grid"
			@contextmenu.stop.prevent="$refs.FileSystem.showContextMenu($event, null)"
		>
			<button type="button" class="file-table-heading" @click.stop="sort('name')">
				<span>Name</span>
				<portal-icon
					v-if="sortBy === 'name'"
					:name="sortDir === 'asc' ? 'chevron-up' : 'chevron-down'"
					:size="14"
				></portal-icon>
			</button>
			<button type="button" class="file-table-heading file-col-modified" @click.stop="sort('updated')">
				<span>Modified</span>
				<portal-icon
					v-if="sortBy === 'updated'"
					:name="sortDir === 'asc' ? 'chevron-up' : 'chevron-down'"
					:size="14"
				></portal-icon>
			</button>
			<button type="button" class="file-table-heading file-col-size" @click.stop="sort('size')">
				<span>Size</span>
				<portal-icon
					v-if="sortBy === 'size'"
					:name="sortDir === 'asc' ? 'chevron-up' : 'chevron-down'"
					:size="14"
				></portal-icon>
			</button>
			<div class="file-table-heading file-col-version">Ver</div>
			<div></div>
		</div>
			<file-system
				ref="FileSystem"
				:sort-by="sortBy"
				:sort-dir="sortDir"
				:parent-folder-id="folderId"
				:show-deleted="showDeleted"
				:parent-deleted="false"
				:depth="0"
				:is-dragging="isDragging"
        :read-only="readOnly"
				:allow-upload="allowUpload"
			></file-system>
		<div class="file-browser-footer" v-if="!readOnly || allowUpload">
			<button type="button" class="file-upload-action" @click.stop="$refs.FileSystem.handleUploadFile()">
				<portal-icon name="upload" :size="16"></portal-icon>
				<span>Upload file</span>
			</button>
		</div>
	</div>
</template>

<script>
	import FileSystem from '@/modules/files/FileSystem';
	export default {
		name: 'Files',

		props: {
			folderId: {
				type: String,
				default: null,
			},
      showDeleted: {
        type: Boolean,
        default: false,
      },
      readOnly: {
        type: Boolean,
        default: false,
      },
			allowUpload: {
				type: Boolean,
				default: false,
			},
		},

		components: { FileSystem },

		data: function() {
			return {
				isDragging: false,
				sortBy: 'name',
				sortDir: 'asc',
			};
		},

		mounted() {
			document.addEventListener('dragstart', this.handleDragStart);
			document.addEventListener('dragover', this.handleDragOver);
			document.addEventListener('dragend', this.handleDragEnd);
			document.addEventListener('drop', this.handleDrop);
		},

		beforeDestroy() {
			document.removeEventListener('dragstart', this.handleDragStart);
			document.removeEventListener('dragover', this.handleDragOver);
			document.removeEventListener('dragend', this.handleDragEnd);
			document.removeEventListener('drop', this.handleDrop);
		},

		methods: {
			sort: function(key) {
				if (this.sortBy === key) {
					this.sortDir = this.sortDir === 'desc' ? 'asc' : 'desc';
				} else {
					this.sortBy = key;
					this.sortDir = 'asc';
				}
			},
			addNew: function() {
				this.$refs.FileSystem.handleUploadFile();
			},
			handleDragStart() {
				this.isDragging = true;
			},
			handleDragOver() {
				this.isDragging = true;
			},
			handleDragEnd() {
				this.isDragging = false;
			},
			handleDrop() {
				this.isDragging = false;
			},
		},

		computed: {},
	};
</script>

<style lang="scss">
	.file-browser {
		container: portal-file-browser / inline-size;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-surface-radius, 14px);
		background: var(--portal-table-row-background, var(--portal-surface));
		overflow: hidden;
	}

	.file-table-grid {
		display: grid;
		grid-template-columns: minmax(220px, 1fr) 140px 100px 72px 48px;
		align-items: center;
	}

	.file-table-header {
		min-height: 44px;
		padding: 0 4px;
		border-bottom: 1px solid var(--portal-border);
		background: var(--brand-surface, var(--v-gray_20-base));
	}

	.file-table-heading {
		min-width: 0;
		height: 36px;
		display: flex;
		align-items: center;
		gap: 5px;
		padding: 0 10px;
		border: 0;
		border-radius: var(--brand-button-radius, 8px);
		background: transparent;
		color: var(--portal-muted);
		font: inherit;
		font-size: 11px;
		font-weight: 680;
		letter-spacing: 0.02em;
		text-align: left;
	}

	button.file-table-heading {
		cursor: pointer;
	}

	button.file-table-heading:hover,
	button.file-table-heading:focus-visible {
		outline: 0;
		background: var(--portal-surface);
		color: var(--portal-text);
	}

	.file-browser-footer {
		padding: 10px 12px;
		border-top: 1px solid var(--portal-border);
		background: var(--brand-surface, var(--v-gray_10-base));
	}

	.file-upload-action {
		min-height: 36px;
		display: inline-flex;
		align-items: center;
		gap: 7px;
		padding: 0 11px;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-button-radius, 9px);
		background: var(--portal-surface);
		color: var(--portal-text);
		font: inherit;
		font-size: 12px;
		font-weight: 650;
		cursor: pointer;
	}

	.file-upload-action:hover,
	.file-upload-action:focus-visible {
		outline: 0;
		border-color: var(--v-primary-base);
		color: var(--v-primary-base);
	}

	@container portal-file-browser (max-width: 760px) {
		.file-table-grid {
			grid-template-columns: minmax(0, 1fr) 140px 48px;
		}

		.file-col-size,
		.file-col-version {
			display: none !important;
		}
	}

	@container portal-file-browser (max-width: 540px) {
		.file-table-grid {
			grid-template-columns: minmax(0, 1fr) 48px;
		}

		.file-col-modified {
			display: none !important;
		}
	}
</style>
